import Vue from 'vue'
import Router from 'vue-router'
import home from '../page/home.vue'
import login from '../page/login.vue'

// import moduleSetting from '../page/publicAccount/management/moduleSetting.vue'
import moduleList from '../page/module/list.vue'
// import functionList from '../page/function/list.vue'
import moduleMarketSetting from '../page/module/main/setting.vue'
// import moduleSingleUserList from '../page/module/main/business/singleUserList.vue'
// import moduleMarketIncList from '../page/module/main/data/marketIncList.vue'
// import moduleMarketIncRealList from '../page/module/main/data/marketIncRealList.vue'

import adBase from '../page/module/ad/adBase'
import adDayBase from '../page/module/ad/adDayBase'
import adDayBudget from '../page/module/ad/adDayBudget'
import adList from '../page/module/ad/adList'
import adOrder from '../page/module/ad/adOrder'
import adUserList from '../page/module/ad/adUserList'
import adExchange from '../page/module/ad/adExchange'
// import adIncrease from '../page/module/ad/adIncrease'
// // import adTrail from '../page/module/ad/adTrail'
// import adStat from '../page/module/ad/adStat'
import adEdit from '../page/module/ad/adEdit'
import adOrderEdit from '../page/module/ad/adOrderEdit'
import adOrderExpress from '../page/module/ad/adOrderExpress'
import adDetail from '../page/module/ad/adDetail'
import adUserDetail from '../page/module/ad/adUserDetail'
import adUserConf from '../page/module/ad/adUserConf'
import adRegister from '../page/module/ad/adRegister'
import adPredict from '../page/module/ad/adPredict'
import adWatchwordList from '../page/module/ad/adWatchwordList'
import adWatchwordEdit from '../page/module/ad/adWatchwordEdit'
import adChnList from '../page/module/ad/adChnList'
import keywordList from '../page/module/ad/keywordList'

import adData from '../page/data/adData'
import adMonthData from '../page/data/adMonthData'
import adMonthSummary from '../page/data/adMonthSummary'
import dsMonthSummary from '../page/data/adDsMonthSummary'
import dsMonthData from '../page/data/adDsMonthData'

import ledgerList from '../page/module/finance/ledgerList'
import ledgerEdit from '../page/module/finance/ledgerEdit'
import ledgerRecordList from '../page/module/finance/ledgerRecordList'

import sjEdit from '../page/module/sj/sjEdit'
import sjList from '../page/module/sj/sjList'

import inboundEdit from '../page/module/stock/inboundEdit'
import inboundList from '../page/module/stock/inboundList'
import outboundEdit from '../page/module/stock/outboundEdit'
import outboundList from '../page/module/stock/outboundList'
import stocktaking from '../page/module/stock/stocktaking'

import shopCategory from '../page/module/shop/shopCategory'
import shopBanner from '../page/module/shop/shopBanner'
import shopFeatureCategory from '../page/module/shop/shopFeatureCategory'
import shopFeatureAttribute from '../page/module/shop/shopFeatureAttribute'
import shopGoodsList from '../page/module/shop/shopGoodsList'
import shopGoodsEdit from '../page/module/shop/shopGoodsEdit'
import shopGoodsStock from '../page/module/shop/shopGoodsStock'
import shopGoodsStockFull from '../page/module/shop/shopGoodsStockFull'
import shopGoodsStockEdit from '../page/module/shop/shopGoodsStockEdit'
import shopOrderList from '../page/module/shop/shopOrderList'
import shopOrderGoodsList from '../page/module/shop/shopOrderGoodsList'
import shopOrderPayList from '../page/module/shop/shopOrderPayList'
import shopAgentUserList from '../page/module/shop/shopAgentUserList'
import shopUserList from '../page/module/shop/shopUserList'
// import shopChnUserList from '../page/module/shop/shopChnUserList'
import shopExchange from '../page/module/shop/shopExchange'

// market
import cardList from '../page/function/card/cardList.vue'
import cardEdit from '../page/function/card/cardEdit.vue'

// manage
import operList from '../page/manage/operList.vue'

// earn
import earnBase from '../page/module/earn/earnBase'
import earnDayBase from '../page/module/earn/earnDayBase'
import taskList from '../page/module/earn/taskList'
import taskEdit from '../page/module/earn/taskEdit'
import earnOrder from '../page/module/earn/earnOrder'
import earnOrderEdit from '../page/module/earn/earnOrderEdit'
import kttList from '../page/module/earn/kttList'
import earnUserList from '../page/module/earn/earnUserList'
import earnUserDetail from '../page/module/earn/earnUserDetail'
import earnExchange from '../page/module/earn/earnExchange'
import earnRequest from '../page/module/earn/earnRequest'
import earnResponse from '../page/module/earn/earnResponse'
import earnExpress from '../page/module/earn/earnExpress'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/moduleList',
    hidden: true
  },
  {
    path: '/',
    title: '模块',
    component: home,
    children: [
      {path: '/moduleList', component: moduleList, name: 'moduleList', meta: {type: 'moduleList', name: '列表'}}
    ],
    type: 'moduleList'
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    hidden: true
  },
  {
    path: '/',
    title: '管理',
    component: home,
    children: [
      {path: '/operList', component: operList, name: 'operList', meta: {type: 'manage', name: '操作员'}}
    ],
    meta: {
      role: ['admin'] // 只允许 admin
    },
    type: 'manage'
  },
  {
    path: '/',
    title: '概述',
    component: home,
    children: [
      {path: '/adBase', component: adBase, name: 'adBase', meta: {type: 'ad', name: '概述'}},
      {path: '/adDayBase', component: adDayBase, name: 'adDayBase', meta: {type: 'ad', name: '每日概述'}},
      {path: '/adDayBudget', component: adDayBudget, name: 'adDayBudget', meta: {type: 'ad', name: '每日预算'}}
    ],
    type: 'ad',
    market: 1
  },
  {
    path: '/',
    title: '广告管理',
    component: home,
    children: [
      {path: '/adList', component: adList, name: 'adList', meta: {type: 'ad', name: '广告列表'}},
      {path: '/adEdit', component: adEdit, name: 'adEdit', meta: {type: 'ad', name: '广告编辑'}, hidden: true},
      {path: '/adRegister', component: adRegister, name: 'adRegister', meta: {type: 'ad', name: '广告预约'}},
      {path: '/adPredict', component: adPredict, name: 'adPredict', meta: {type: 'ad', name: '预约记录'}, hidden: true},
      {path: '/adOrder', component: adOrder, name: 'adOrder', meta: {type: 'ad', name: '广告订单'}},
      {path: '/adOrderEdit', component: adOrderEdit, name: 'adOrderEdit', meta: {type: 'ad', name: '订单编辑'}, hidden: true},
      {path: '/adDetail', component: adDetail, name: 'adDetail', meta: {type: 'ad', name: '广告明细'}, hidden: true},
      {path: '/adUserConf', component: adUserConf, name: 'adUserConf', meta: {type: 'ad', name: '广告用户配置'}, hidden: true},
      {path: '/adWatchwordList', component: adWatchwordList, name: 'adWatchwordList', meta: {type: 'ad', name: '广告口令'}, hidden: true},
      {path: '/adWatchwordEdit', component: adWatchwordEdit, name: 'adWatchwordEdit', meta: {type: 'ad', name: '口令编辑'}, hidden: true},
      {path: '/ledgerList', component: ledgerList, name: 'ledgerList', meta: {type: 'ad', name: '收支列表'}},
      {path: '/ledgerEdit', component: ledgerEdit, name: 'ledgerEdit', meta: {type: 'ad', name: '收支编辑'}, hidden: true},
      {path: '/adOrderExpress', component: adOrderExpress, name: 'adOrderExpress', meta: {type: 'ad', name: '订单快递'}},
      {path: '/sjList', component: sjList, name: 'sjList', meta: {type: 'ad', name: '短链列表'}},
      {path: '/sjEdit', component: sjEdit, name: 'sjEdit', meta: {type: 'ad', name: '短链编辑'}, hidden: true},
      {path: '/ledgerRecordList', component: ledgerRecordList, name: 'ledgerRecordList', meta: {type: 'ad', name: '收支记录'}}
    ],
    type: 'ad',
    market: 1
  },
  {
    path: '/',
    title: '业务功能',
    component: home,
    children: [
      {path: '/adChnList', component: adChnList, name: 'adChnList', meta: {type: 'ad', name: '下家列表'}},
      {path: '/adUserList', component: adUserList, name: 'adUserList', meta: {type: 'ad', name: '用户列表'}},
      {path: '/adUserDetail', component: adUserDetail, name: 'adUserDetail', meta: {type: 'ad', name: '用户详情'}, hidden: true},
      {path: '/adExchange', component: adExchange, name: 'adExchange', meta: {type: 'ad', name: '兑换审核'}},
      {path: '/keywordList', component: keywordList, name: 'keywordList', meta: {type: 'ad', name: '口令折扣', role: ['admin']}}
    ],
    type: 'ad',
    market: 1
  },
  {
    path: '/',
    title: '数据功能',
    component: home,
    children: [
      {path: '/adData', component: adData, name: 'adData', meta: {type: 'ad', name: '广告数据'}},
      {path: '/adMonthData', component: adMonthData, name: 'adMonthData', meta: {type: 'ad', name: '每月数据'}},
      {path: '/adMonthSummary', component: adMonthSummary, name: 'adMonthSummary', meta: {type: 'ad', name: '每月汇总'}},
      {path: '/dsMonthSummary', component: dsMonthSummary, name: 'dsMonthSummary', meta: {type: 'ad', name: 'ds汇总'}},
      {path: '/dsMonthData', component: dsMonthData, name: 'dsMonthData', meta: {type: 'ad', name: 'ds每月'}}
    ],
    type: 'ad',
    meta: {
      role: ['admin', 'finance']
    },
    market: 1
  },
  {
    path: '/',
    title: '囤货列表',
    component: home,
    children: [
      {path: '/stocktaking', component: stocktaking, name: 'stocktaking', meta: {type: 'ad', name: '库存表'}},
      {path: '/inboundEdit', component: inboundEdit, name: 'inboundEdit', meta: {type: 'ad', name: '入库编辑'}, hidden: true},
      {path: '/inboundList', component: inboundList, name: 'inboundList', meta: {type: 'ad', name: '入库表'}},
      {path: '/outboundEdit', component: outboundEdit, name: 'outboundEdit', meta: {type: 'ad', name: '出库编辑'}, hidden: true},
      {path: '/outboundList', component: outboundList, name: 'outboundList', meta: {type: 'ad', name: '出库表'}}
    ],
    type: 'ad',
    meta: {
      role: ['store']
    },
    market: 1
  },
  {
    path: '/',
    title: '概述',
    component: home,
    children: [
      {path: '/shopBase', component: adBase, name: 'adBase', meta: {type: 'shop', name: '概述'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '模块设置',
    component: home,
    children: [
      {path: '/shopModuleSetting', component: moduleMarketSetting, name: 'shopModuleSetting', meta: {type: 'shop', name: '参数设置'}},
      {path: '/cardList', component: cardList, name: 'cardList', meta: {type: 'shop', name: '名片列表'}},
      {path: '/cardEdit', component: cardEdit, name: 'cardEdit', hidden: true, meta: {type: 'shop', name: '编辑名片'}},
      {path: '/shopCategory', component: shopCategory, name: 'shopCategory', meta: {type: 'shop', name: '商品分类'}},
      {path: '/shopBanner', component: shopBanner, name: 'shopBanner', meta: {type: 'shop', name: 'Banner图'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '商品',
    component: home,
    children: [
      {path: '/shopGoodsList', component: shopGoodsList, name: 'shopGoodsList', meta: {type: 'shop', name: '商品列表'}},
      {path: '/shopGoodsEdit', component: shopGoodsEdit, name: 'shopGoodsEdit', meta: {type: 'shop', name: '商品编辑'}, hidden: true},
      {path: '/shopFeatureCategory', component: shopFeatureCategory, name: 'shopFeatureCategory', meta: {type: 'shop', name: '规格分类'}, hidden: true},
      {path: '/shopFeatureAttibute', component: shopFeatureAttribute, name: 'shopFeatureAttribute', meta: {type: 'shop', name: '规格属性'}, hidden: true},
      {path: '/shopGoodsStockEdit', component: shopGoodsStockEdit, name: 'shopGoodsStockEdit', meta: {type: 'shop', name: '商品库存编辑'}, hidden: true},
      {path: '/shopGoodsStockFull', component: shopGoodsStockFull, name: 'shopGoodsStockFull', meta: {type: 'shop', name: '库存全列表'}, hidden: true},
      {path: '/shopGoodsStock', component: shopGoodsStock, name: 'shopGoodsStock', meta: {type: 'shop', name: '库存列表'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '订单',
    component: home,
    children: [
      {path: '/shopOrderList', component: shopOrderList, name: 'shopOrderList', meta: {type: 'shop', name: '订单列表'}},
      {path: '/shopOrderGoodsList', component: shopOrderGoodsList, name: 'shopOrderGoodsList', meta: {type: 'shop', name: '商品订单'}},
      {path: '/shopPayList', component: shopOrderPayList, name: 'shopOrderPayList', meta: {type: 'shop', name: '支付列表'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '代理',
    component: home,
    children: [
      {path: '/shopAgentUserList', component: shopAgentUserList, name: 'shopAgentUserList', meta: {type: 'shop', name: '代理用户'}},
      {path: '/shopAgentGoods', component: adBase, name: 'adBase', meta: {type: 'shop', name: '商品统计'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '用户',
    component: home,
    children: [
      {path: '/shopUserList', component: shopUserList, name: 'shopUserList', meta: {type: 'shop', name: '用户列表'}},
      {path: '/shopUserDetail', component: adUserDetail, name: 'adUserDetail', meta: {type: 'shop', name: '用户详情'}, hidden: true},
      {path: '/shopExchange', component: shopExchange, name: 'shopExchange', meta: {type: 'shop', name: '兑换审核'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '数据功能',
    component: home,
    children: [
      {path: '/shopDayData', component: adBase, name: 'adBase', meta: {type: 'shop', name: '每日数据'}},
      {path: '/shopMonthData', component: adBase, name: 'adBase', meta: {type: 'shop', name: '每月数据'}},
      {path: '/shopGoodsData', component: adBase, name: 'adBase', meta: {type: 'shop', name: '商品数据'}},
      {path: '/shopOrderData', component: adBase, name: 'adBase', meta: {type: 'shop', name: '订单数据'}}
    ],
    type: 'shop',
    market: 2
  },
  {
    path: '/',
    title: '概述',
    component: home,
    children: [
      {path: '/earnBase', component: earnBase, name: 'earnBase', meta: {type: 'earn', name: '概述'}},
      {path: '/earnDayBase', component: earnDayBase, name: 'earnDayBase', meta: {type: 'earn', name: '每日概述'}}
    ],
    type: 'earn',
    market: 3
  },
  {
    path: '/',
    title: '模块设置',
    component: home,
    children: [
      {path: '/earnModuleSetting', component: moduleMarketSetting, name: 'earnModuleSetting', meta: {type: 'earn', name: '参数设置'}}
    ],
    type: 'earn',
    market: 3
  },
  {
    path: '/',
    title: '任务',
    component: home,
    children: [
      {path: '/taskList', component: taskList, name: 'taskList', meta: {type: 'earn', name: '任务列表'}},
      {path: '/taskEdit', component: taskEdit, name: 'taskEdit', meta: {type: 'earn', name: '任务编辑'}, hidden: true},
      {path: '/earnOrder', component: earnOrder, name: 'earnOrder', meta: {type: 'earn', name: '订单列表'}},
      {path: '/earnOrderEdit', component: earnOrderEdit, name: 'earnOrderEdit', meta: {type: 'earn', name: '商品编辑'}, hidden: true},
      {path: '/earnLedgerList', component: ledgerList, name: 'ledgerList', meta: {type: 'earn', name: '收支列表'}},
      {path: '/earnLedgerEdit', component: ledgerEdit, name: 'ledgerEdit', meta: {type: 'earn', name: '收支编辑'}, hidden: true},
      {path: '/kttList', component: kttList, name: 'kttList', meta: {type: 'earn', name: '快团团'}, hidden: true},
      {path: '/earnRequest', component: earnRequest, name: 'earnRequest', meta: {type: 'earn', name: '请求配置'}},
      {path: '/earnResponse', component: earnResponse, name: 'earnResponse', meta: {type: 'earn', name: '口令列表'}},
      {path: '/earnExpress', component: earnExpress, name: 'earnExpress', meta: {type: 'earn', name: '快递列表'}}
    ],
    type: 'earn',
    market: 3
  },
  {
    path: '/',
    title: '用户',
    component: home,
    children: [
      {path: '/earnUserList', component: earnUserList, name: 'earnUserList', meta: {type: 'earn', name: '用户列表'}},
      {path: '/earnUserDetail', component: earnUserDetail, name: 'earnUserDetail', meta: {type: 'earn', name: '用户明细'}, hidden: true},
      {path: '/earnExchange', component: earnExchange, name: 'earnExchange', meta: {type: 'earn', name: '兑换审核'}}
    ],
    type: 'earn',
    market: 3
  }
]

export default new Router({
  base: '/',
  routes: routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js